import { render, staticRenderFns } from "./FormBoxes.vue?vue&type=template&id=6534c7c2&scoped=true"
import script from "./FormBoxes.vue?vue&type=script&lang=js"
export * from "./FormBoxes.vue?vue&type=script&lang=js"
import style0 from "./FormBoxes.vue?vue&type=style&index=0&id=6534c7c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6534c7c2",
  null
  
)

export default component.exports